import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { sortArray } from 'utils/helpers';

import United_Kingdom from 'ui/assets/images/icons/united_kingdom_icon.png';
import Ireland from 'ui/assets/images/icons/ireland_icon.png';
import Canada from 'ui/assets/images/icons/canada_icon.png';
import USA from 'ui/assets/images/icons/usa_icon.png';
import Australia from 'ui/assets/images/icons/australia_icon.png';
import New_Zealand from 'ui/assets/images/icons/newzealand_icon.png';
import Arrow from 'ui/assets/images/icons/table_dropdown_icon.svg';

import './CountriesDropDown.scss';

@observer
export default class CountryDropDown extends Component {
	static propTypes = {
		countries: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
			.isRequired,
		toggle: PropTypes.func.isRequired,
		countryChange: PropTypes.func.isRequired,
		selectedCountry: PropTypes.string.isRequired,
		expanded: PropTypes.bool.isRequired,
	};

	constructor(props) {
		super(props);

		this.countries = sortArray(this.props.countries, 'id');
	}

	componentDidMount() {
		document.addEventListener('click', this.handleDocumentClick.bind(this));
	}

	componentWillUnmount() {
		document.removeEventListener('click', this.handleDocumentClick.bind(this));
	}

	isOpen = false;
	mouseWasDown = false;
	mouseWasUp = false;

	handleDocumentClick() {
		if (!this.mouseWasDown && !this.mouseWasUp && this.isOpen) {
			this.isOpen = false;
			this.props.toggle();
		}

		this.mouseWasDown = false;
		this.mouseWasUp = false;
	}

	onClick(country) {
		this.props.countryChange(country);
	}

	toggle(e) {
		e.preventDefault();

		this.isOpen = !this.isOpen;
		this.props.toggle();
	}

	handleMouseDown() {
		this.mouseWasDown = true;
	}

	handleMouseUp() {
		this.mouseWasUp = true;
	}

	isSelectedCountry(country) {
		return country === this.props.selectedCountry;
	}

	getImageSrc(countryName) {
		let src = '';
		switch (countryName) {
			case 'United Kingdom':
				src = United_Kingdom;
				break;
			case 'Ireland':
				src = Ireland;
				break;
			case 'Canada':
				src = Canada;
				break;
			case 'USA':
				src = USA;
				break;
			case 'Australia':
				src = Australia;
				break;
			case 'New Zealand':
				src = New_Zealand;
				break;
		}
		return src;
	}

	render() {
		const { selectedCountry, expanded } = this.props;

		return (
			<div className="CountriesDropDown">
				<div
					className="CountriesDropDown-container"
					onMouseDown={this.handleMouseDown.bind(this)}
					onMouseUp={this.handleMouseUp.bind(this)}
					onClick={this.toggle.bind(this)}
				>
					{selectedCountry}
					<span className="arrow-icon" />
					{expanded &&
						<div className="CountriesDropDown-container-content">
							<span className="content-arrow">
								<img src={Arrow} />
							</span>
							{this.countries.map((country, index) =>
								<div
									className={`CountriesDropDown-container-content-country--${index} ${this.isSelectedCountry(
										country.name
									)
										? 'selected'
										: ''}`}
									key={index}
									onClick={this.onClick.bind(this, country)}
								>
									<img
										src={this.getImageSrc(country.name)}
										alt={country.name}
									/>
									{country.name}
								</div>
							)}
						</div>}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/CountriesDropdown/index.js